import React, { useState, useEffect } from "react";
import "./login.css";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { doc, getDoc, updateDoc, setDoc } from "firebase/firestore";
import { database } from "../../database/firebase";
import axios from "axios";
import Swal from 'sweetalert2';
import { insertScore, alreadyPlayed,updateReport } from "../../api/scoreApi";
import logoUrl from "../../img/logo.png";
import { useBrandCtaVars } from "../../hooks/useBrandCtaVars";
import bgDesk from "../../img/bg.jpg";
import bgMob from "../../img/bgmob.jpg";
import { sendReport } from "../../functions/sendReport";
import MonkeyBackdrop from "../../components/MonkeyBackdrop";

function Login({ updateHeader }) {
  const location = useLocation();

  // Use URLSearchParams to access the query parameters
  const queryParams = new URLSearchParams(location.search);
  const getOtp = queryParams.get('otp');
  const role = queryParams.get('role');
  const [otp, setOtp] = useState(getOtp);
  const [isLoggedIn, setIsLoggedIn] = useState(false); // To control login state
  const [sessionUserData, setSessionUserData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoggedIn) {
      setSessionUserData(null);
      return;
    }
    try {
      setSessionUserData(JSON.parse(sessionStorage.getItem("userData") || "null"));
    } catch {
      setSessionUserData(null);
    }
  }, [isLoggedIn]);

  const { style: loginCtaVars, themed: loginCtaThemed } = useBrandCtaVars(
    sessionUserData,
    sessionUserData?.companyLogoUrl || logoUrl
  );
  // const [teamName, SetTeamName] = useState();

  const handleSuccess = (msg) => {
    Swal.fire({
      title: 'Success!',
      text: msg,
      customClass: {
        popup: 'custom-success-popup' // Apply your custom class
      }
    });
  };

  const handleError = (msg) => {
    Swal.fire({
      title: 'Oops...',
      text: msg,
      customClass: {
        popup: 'custom-success-popup' // Apply your custom class
      }
    });
  };
  function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
  function generateRandomUser() {
    const randomString = 'demo' + Math.floor(Math.random() * 10000);
    return {
      data: {
        data: {
          id: Math.floor(Math.random() * 100000),
          email: `${randomString}@gmail.com`,
          userId: randomString,
          firstName: randomString,
          lastName: randomString,
          employeeId: `EM${Math.floor(Math.random() * 1000).toString().padStart(3, '0')}`,
          sessionId: "demobypass"+uuidv4(),
          organizationId: "demobypass",
          roles: "demoRoles",
          gameId: "demogame",
          reportId: `Report${Math.floor(Math.random() * 1000).toString().padStart(3, '0')}`
        }
      }
    };
  }
  const handleLogin = () => {
    if (queryParams.get('save')) {
      console.log("ignoring latest update...");
    } else {

      if (queryParams.get('demo') === 'true') {
        // const userId=;
        // const email=;
        // const firstName=;
        const response = generateRandomUser();

        loginCheck(response, "demo");
      } else {

        let apiUrl;
        const requestData = { otp: otp };
        let source = null;

        if (role === 'GUEST_USER') {
          apiUrl = process.env.REACT_APP_FIREBASE_GUEST_USER_API;
          requestData.role = 'GUEST_USER';
          source = 'GUEST_USER'
        } else {
          apiUrl = process.env.REACT_APP_FIREBASE_LOGIN_API;
          source = 'ORG_USER'
        }


        const headers = {
          'client-secret': process.env.REACT_APP_CLIENT_SECRET,
          'Content-Type': 'application/json'
        };

        const method = "POST";
        if (["POST", "PUT"].includes(method)) {
          headers["Idempotency-Key"] = uuidv4();
          console.log("Added Idempotency-Key:", headers["Idempotency-Key"]);
        }
        // const headers = {
        //   'Content-Type': 'application/json'
        // };

        console.log(apiUrl);
        axios.post(apiUrl, requestData, { headers })
          .then(response => {
            console.log("API TRIGGER", response);
            if (response.data.message === 'LOGIN SUCCESS') {
              axios.get(
                process.env.REACT_APP_ORG_API + "/" + response.data.data.organizationId,
                { headers } // Ensure headers are included properly
              )
                .then(responseOrg => {
                  if (responseOrg.data.message === 'ORGANIZATIONS_FETCHED_SUCCESSFULLY') {
                    let companyLogo = process.env.REACT_APP_S3BUCKET_URL + '/' + responseOrg.data.organization.companyLogo;
                    console.log("companyLogo", companyLogo);
                    console.log("responseOrg", responseOrg);
                    if (typeof updateHeader === "function") {
                      try {
                        updateHeader({
                          imageUrl: companyLogo,
                          backButtonRedirect: process.env.REACT_APP_BASE_URL + "/game-detail/" + response.data.data.gameId,
                        });
                      } catch (err) {
                        console.error("updateHeader threw:", err, updateHeader);
                      }
                    } else {
                      console.error("updateHeader is not a function — aborting updateHeader call:", updateHeader);
                    }
                  
                  }
                  console.log("responseOrg", responseOrg);
                })
                .catch(error => {
                  console.error("Error fetching organization:", error);
                });

                loginCheck(response, source);

            } else {
              handleError('Login failed! Please try again.');
            }

          })
          .catch(error => {
            console.error('Login Failed:', error.response?.data?.err?.message || 'An error occurred');
            handleError('Login failed! Please try again.');

          });
      }
    }
  };

  async function loginCheck(response, source) {
    try {
      const data = response.data.data;
      console.log("loginCheck:", data);

      // 1️⃣ Extract core user info
      const isGuest = source === "GUEST_USER";
      const userId = isGuest ? data.id : data.userId;

      let name = `${data.firstName || ""} ${data.lastName || ""}`.trim();
      let email = data.email || data.employeeId || "";
      let token = isGuest ? "" : data.token;

      if (isGuest && !data.firstName) {
        if (data.email) name = data.email.split("@")[0];
        else if (data.employeeId) name = data.employeeId;
        else name = "Guest";
      }

      // 2️⃣ Check team info
      const checkData = {
        sessionId: data.sessionId,
        organizationId: data.organizationId,
        email: data.email,
      };


      const userData = {
        userId,
        sessionId: data.sessionId,
        organizationId: data.organizationId,
        roles: source,
        gameId: data.gameId,
        name,
        email,
        expiry: Date.now() + 24 * 60 * 60 * 1000,
        source,
        token,
      };

      console.log("Prepared userData:", userData);

      const userDocRef = doc(database, `sessions/${userData.sessionId}/users/${userData.userId}`);
      const userSnapshot = await getDoc(userDocRef);

      if (userSnapshot.exists()) {
        const userDocData = userSnapshot.data();
        console.log("User exists:", userDocData);

        if (userDocData.reportId) {
          // ✅ Existing reportId found → just save and proceed
          console.log("Existing reportId:", userDocData.reportId);
          const updatedUserData = { ...userData, reportId: userDocData.reportId };
          sessionStorage.setItem("userData", JSON.stringify(updatedUserData));
          setIsLoggedIn(true);
        }
      } else {
        // 6️⃣ User does not exist → create user first, then generate report
        await setDoc(userDocRef, {
          userId: userData.userId,
          organizationId: userData.organizationId,
          sessionId: userData.sessionId,
          name: userData.name,
          gameId: userData.gameId,
          email: userData.email,
          timestamp: Date.now(),
          source: userData.source,
          roles: userData.roles,
          token: userData.token|| "",
          live:false,
          
        });

        console.log("User document created successfully.");
        await callPhpReportAPI(userData, response);

        
      }
    } catch (error) {
      console.error("Error in loginCheck:", error);
      handleError("There was an error during login. Please try again.");
    }

    function callPhpReportAPI(userData,response) {


      let reportData = {
        userId: userData.userId,
        sessionId: userData.sessionId,
        organizationId: userData.organizationId,
        roles: userData.roles,
        name: userData.name,
        email: userData.email,
        gameId: userData.gameId,
        points: 0,
        time: "00:00"
  
      };
  
      const reportData1 = {
        userId: userData.userid || userData.userId,
        sessionId: userData.sessionId,
        organizationId: userData.organizationId
      };
  
      console.log("reportData1--------", reportData1);
  
      alreadyPlayed(reportData1)
        .then(res => {
          console.log("res--------",res);
  
          // if PHP returned false or empty
          if (!res) {
            return; // print nothing
          }
          const data = typeof res === "string" ? JSON.parse(res) : res;
          console.log("alreadyPlayed data", data);
  
          if (data?.status === "success") {
            handleSuccess("You have already played").then(result => {
              if (result.isConfirmed) {
                window.location.href = process.env.REACT_APP_BASE_URL;
              }
            });
          } else {
            insertScore(reportData).then((res) => {
              console.log("Insert response:", res);
  
              if (userData.source == "demo") {
                setIsLoggedIn(true);
                sessionStorage.setItem('userData', JSON.stringify(userData));
  
              } else {
                if (res.status === "exists") {
                  console.log("Already inserted, record:", res.data);
                  res.data.token = userData.token;
                  callReportAPIAndContinue(res.data);
                } else if (res.status === "success") {
                  console.log("New score inserted.");
                  callReportAPIAndContinue(userData);
                }
              }
            })
          }
        })
        .catch(err => {
          console.error(err);
        });
  
  
    }
    async function callReportAPIAndContinue(userData) {
      try {
        const isGuest = userData.roles === "GUEST_USER";

        const reportRequestData={ 
          gameId: userData.gameId,
              name: userData.name,
              sessionId: userData.sessionId,
              userId: userData.userId,
              organizationId: userData.organizationId,
              points: 0,
              time: "00:00",
              ans: "",
              token: userData.token,
              role: userData.roles

        }
          console.log("reportRequestData--", reportRequestData);

       const datareport = await sendReport(reportRequestData);
       console.log("reportId",datareport);
        if (datareport) {
          //updatedUserData.reportId = reportId
          let reportId;
            if(userData.roles === "GUEST_USER"){
              reportId = datareport.data.id || null;
                console.log("Report ID:", reportId);
            }else{
              reportId = datareport.data.reportId|| null;
              console.log("Report ID:", reportId);
            }
          
          //console.log("✅ Report created successfully:", reportId);

          // Update Firestore with reportId
          const userDocRef = doc(database, `sessions/${userData.sessionId}/users/${userData.userId}`);
          console.log("userDocRef--", userDocRef);

          await updateDoc(userDocRef, { reportId});

          console.log("Firestore updated with reportId:", reportId);
          // Update local data
          const updatedUserData = { ...userData, reportId };
          console.log("updatedUserData--", updatedUserData);
          updateReport(updatedUserData).then((res) => {
            console.log("Update response:", res);
          });

          sessionStorage.setItem("userData", JSON.stringify(updatedUserData));
          setIsLoggedIn(true);
        } else {
          console.warn("Report creation did not return success:", datareport);
        }
      } catch (error) {
        console.error("Report API Error:", error.response?.data?.err?.message || error.message);
        handleError("Unable to create report. Please try again.");
      }
    }


  }


  useEffect(() => {
    // First-time login
    const storedUserData = JSON.parse(sessionStorage.getItem('userData'));
    if (storedUserData) {
      sessionStorage.removeItem('userData');
    }
    handleLogin();
  }, []); // Runs once on component mount

  useEffect(() => {
    const applyBackground = () => {
      const body = document.body;
      const backgroundImage = window.innerWidth <= 768 ? bgMob : bgDesk;
      if (body.classList.contains("common-bg")) {
        body.style.backgroundImage = `url(${backgroundImage})`;
      }
    };
    applyBackground();
    window.addEventListener("resize", applyBackground);
    return () => window.removeEventListener("resize", applyBackground);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      const params = new URLSearchParams(location.search);
      if (params.get("save")) {
        setIsLoggedIn(true);
      }
    }, 1000);
    return () => clearTimeout(timer);
  }, [location.search]);

  return (
    <>
      <div className="login-main-container" style={{ textAlign: "center" }}>
        <MonkeyBackdrop />

        <div className="login-main-container1" style={{ textAlign: "center" }}>
          <img src={logoUrl} className="login-logo" alt="" />
        </div>
        {isLoggedIn ? (
          <div style={{ textAlign: "center" }}>
            <Link
              to="/intro"
              className={
                loginCtaThemed ? "begin-play-btn begin-play-btn--themed" : "begin-play-btn"
              }
              style={loginCtaThemed ? loginCtaVars : undefined}
            >
              Begin play
            </Link>
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  );
}

export default Login;